module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921042334_T.6e4bf89e.jpg";